'use client';
import { capture, EventType } from '@Soultrics/_utils/events';

/**
 * Wrapper to preserve event tracking in Hero Hook Form fields
 * Call this function to wrap field props with event tracking
 */
export function withEventTracking<
  T extends { onBlur?: (e: React.FocusEvent) => void },
>(props: T): T {
  const originalOnBlur = props.onBlur;

  return {
    ...props,
    onBlur: (e: React.FocusEvent) => {
      capture(EventType.TEXT_INPUT);
      originalOnBlur?.(e);
    },
  };
}

/**
 * Hook to add event tracking to field props
 */
export function useEventTracking() {
  return {
    onBlur: () => {
      capture(EventType.TEXT_INPUT);
    },
  };
}
